import { translate } from '../translate';

export const DISCOUNT_CATEGORY_UNSPECIFIED = 'DISCOUNT_CATEGORY_UNSPECIFIED';

export type DealBadgeIconType = 'skyscanner' | 'time';

type DealMessageBadge = Record<
  string,
  { text: string; icon: DealBadgeIconType; contextLine?: string }
>;

export const dealMessageBadges: DealMessageBadge = {
  DYNAMIC_OFFER_EXCLUSIVE_TO_SKYSCANNER: {
    text: translate('deal_message_exclusive_to_skyscanner'), // Exclusive to us
    icon: 'skyscanner',
  },
  DYNAMIC_OFFER_DEAL: {
    text: translate('deal_message_deal'), // Deal
    icon: 'skyscanner',
  },
  FLASH_SALE_EXCLUSIVE_TO_SKYSCANNER: {
    text: translate('deal_message_exclusive_to_skyscanner'), // Exclusive to us
    icon: 'time',
    contextLine: translate('deal_message_context_time_limited'), // Time limited deal
  },
  FLASH_SALE_ON_SALE: {
    text: translate('deal_message_on_sale'), // On sale
    icon: 'time',
    contextLine: translate('deal_message_context_time_limited'), // Time limited deal
  },
};
